import { FilterGroupState } from "features/ui/Filters/FilterBuilder/types";
import FilterTypeWrap from "features/ui/Filters/FilterTypes/FilterTypeWrap";
import { FilterOperator } from "features/ui/Filters/types";
import { SchemaEntry } from "features/ui/MaterialTable";

interface Props {
  attribute: string | null;
  operator: FilterOperator | null;
  values: string[] | null;
  schema?: SchemaEntry<string>;
  onChange: (values: string[]) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  occursFilterSelector?: boolean;
  fullWidth?: boolean;
  isInsideFilterBuilder?: boolean;
  searchIcon?: boolean;
  placeholder?: string;
  multiSelect?: boolean;
  defaultLoadLimit?: number;
  limitTags?: number;
}

const ValuesSelect = ({
  attribute,
  operator,
  values,
  schema,
  onChange,
  disabled,
  autoFocus,
  occursFilterSelector,
  fullWidth,
  isInsideFilterBuilder = false,
  searchIcon,
  placeholder,
  multiSelect = true,
  defaultLoadLimit,
  limitTags,
}: Props) => {
  const filterSchema = schema?.filter;

  if (!attribute || !operator || !filterSchema) return;

  // we're only using this format because FilterTypeWrap requires it
  const currentRowFilters: FilterGroupState | undefined = attribute
    ? {
        id: "group-0",
        type: "group",
        anyAll: "all",
        children: [
          {
            id: attribute,
            type: "row",
            attribute,
            values: values || [],
            operator,
          },
        ],
      }
    : undefined;

  return (
    <FilterTypeWrap
      autoFocus={autoFocus}
      isActiveFilter={false}
      selectedOperatorId={operator}
      initialized={true}
      currentFilterSchema={filterSchema}
      onValuesChanged={onChange}
      filters={currentRowFilters}
      className="flex justify-between"
      disabled={disabled}
      isAdvancedFilterEditor
      fullWidth={fullWidth}
      occursFilterSelector={occursFilterSelector}
      isInsideFilterBuilder={isInsideFilterBuilder}
      searchIcon={searchIcon}
      placeholder={placeholder}
      multiSelect={multiSelect}
      defaultLoadLimit={defaultLoadLimit}
      limitTags={limitTags}
      relationSchema={schema?.relationSchema}
    />
  );
};

export default ValuesSelect;
